/* eslint-disable react/no-unstable-nested-components */
import { Table } from "@jhool-io/fe-components";
import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { IClientAllergy } from "../../types/e-prescribe.types";
import { formatDate } from "../../../../utils/helpers";
import { getStatusForDisplay } from "../../helpers/e-prescribe.helpers";

interface ClientAllergyListTableProps {
    data: IClientAllergy[];
}

export default function ClientAllergyListTable({
    data,
}: ClientAllergyListTableProps) {
    const columns: ColumnDef<IClientAllergy>[] = useMemo(() => {
        return [
            {
                accessorKey: "allergy_name",
                header: "Allergy Name",
                cell: ({ row }) => (
                    <span className="capitalize">
                        {row.original.allergy_name ?? "--"}
                    </span>
                ),
            },
            {
                accessorKey: "allergy_code",
                header: "Allergy Code",
                cell: ({ row }) => row.original.allergy_code ?? "--",
            },
            {
                accessorKey: "code_system",
                header: "Code System",
                cell: ({ row }) => row.original.code_system ?? "--",
            },
            {
                accessorKey: "reaction",
                header: "Reaction",
                cell: ({ row }) => row.original.reaction ?? "--",
            },
            {
                accessorKey: "severity",
                header: "Severity",
                cell: ({ row }) => row.original.severity ?? "--",
            },
            {
                accessorKey: "status",
                header: "Status",
                cell: ({ row }) => (
                    <span>{getStatusForDisplay(row.original.status)}</span>
                ),
            },
            {
                accessorKey: "onset_date",
                header: "Onset Date",
                cell: ({ row }) =>
                    row.original.onset_date
                        ? formatDate(row.original.onset_date, true)
                        : "--",
            },
            {
                accessorKey: "created_at",
                header: "Date Added",
                cell: ({ row }) =>
                    row.original.created_at
                        ? formatDate(row.original.created_at)
                        : "--",
            },
        ];
    }, []);

    return <Table data={data} columns={columns} />;
}
